import { render, staticRenderFns } from "./back_merced.vue?vue&type=template&id=38421ec1&"
import script from "./back_merced.vue?vue&type=script&lang=js&"
export * from "./back_merced.vue?vue&type=script&lang=js&"
import style0 from "./back_merced.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports